/**
 * 乐读绘本租书管理
 * 表格表头标题
 */
// 图书列表
export const columnsBookList = [
  {
    type: 'selection',
    width: '55'
  },
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'bookCode',
    label: '图书编号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'coverUrl',
    label: '封面',
    slotName: 'coverImage',
    headerAlign: 'center'
  },
  {
    prop: 'bookName',
    label: '名称',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'types',
    label: '归属分类',
    slotName: 'bookTypes',
    headerAlign: 'center',
    align: 'left',
    width: '135'
  },
  {
    prop: 'isLimitFree',
    label: '所属专区',
    slotName: 'isLimitFree',
    headerAlign: 'center',
    width: '135'
  },
  {
    prop: 'rentCount',
    label: '租用次数',
    slotName: 'rentCount',
    headerAlign: 'center'
  }
];
// 图书分类
export const columnsBookType = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'name',
    label: '类别名称',
    headerAlign: 'center'
  },
  {
    prop: 'createDate',
    label: '创建时间',
    headerAlign: 'center'
  },
  {
    label: '操作',
    slotName: 'defaultType',
    headerAlign: 'center',
    width: '210'
  }
];
// 免费图书
export const columnsFreeBooks = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'bookCode',
    label: '图书编号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'coverUrl',
    label: '封面',
    slotName: 'coverImage',
    headerAlign: 'center'
  },
  {
    prop: 'bookName',
    label: '名称',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'types',
    label: '归属分类',
    slotName: 'bookTypesFreeBooks',
    headerAlign: 'center',
    align: 'left'
  },
  {
    prop: 'rentCount',
    label: '租用次数',
    slotName: 'rentCount',
    headerAlign: 'center'
  },
  {
    label: '操作',
    slotName: 'defaultFree',
    headerAlign: 'center'
  }
];
// 租书记录
export const columnsRentBook = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'bookCode',
    label: '图书编号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'coverUrl',
    label: '封面',
    slotName: 'coverImage',
    headerAlign: 'center'
  },
  {
    prop: 'bookName',
    label: '名称',
    align: 'left',
    slotName: 'rentName',
    headerAlign: 'center'
  },
  {
    prop: 'accountPhone',
    label: '租用超管账号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'deviceNo',
    label: '租用设备SN号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'createDate',
    label: '创建时间',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'outTradeNo',
    label: '流水号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'orderNo',
    label: '租书订单号',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'payTime',
    label: '支付时间',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'payAmount',
    label: '支付金额',
    align: 'right',
    headerAlign: 'right'
  }
];
// 预警监控
export const columnsWarnList = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'accountPhone',
    label: '超管账号',
    headerAlign: 'center'
  },
  {
    prop: 'accountFrozen',
    label: '账号状态',
    headerAlign: 'center',
    slotName: 'accountFrozen'
  },
  {
    label: '操作',
    slotName: 'defaultWarn',
    headerAlign: 'center'
  }
];
// 预警监控白名单管理
export const columnsWarnListAdd = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'mobile',
    label: '超管账号（手机号）',
    headerAlign: 'center'
  },
  {
    prop: 'createDate',
    label: '添加时间',
    headerAlign: 'center'
  },
  {
    label: '操作',
    slotName: 'defaultWarnAdd',
    headerAlign: 'center'
  }
];
// 预警监控详情
export const columnsWarnListDetail = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'createDate',
    label: '预警时间',
    headerAlign: 'center'
  },
  {
    prop: 'configType',
    label: '监控规则',
    slotName: 'configTypeDetail',
    headerAlign: 'center'
  },
  {
    prop: 'bookNum',
    label: '监控数量',
    slotName: 'bookNum',
    headerAlign: 'center'
  }
];
